import React, { ChangeEvent } from 'react';

import { getClassNames, isNumeric } from '../../../../utils/util';

import { ReactComponent as ArrowDownIcon } from '../../../../resources/icons/arrow-down.svg';
import { ReactComponent as ArrowUpIcon } from '../../../../resources/icons/arrow-up.svg';

import './number-picker.scss';

type Props = {
  value: string | number;
  onChange: (value: number | string) => void;
  disabled?: boolean;
  hideArrows?: boolean;
};

const NumberPicker = ({ value = 0, onChange, disabled = false, hideArrows = false }: Props) => {
  const handleInputChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const { value } = target;
    if (value === '') {
      onChange(0);
    }

    if (isNumeric(value)) {
      onChange(parseInt(value));
    }
  };

  const handleArrowUpClick = () => {
    if (disabled) return;

    if (value === 'Free') {
      onChange(0);
      return;
    }

    onChange((value as number) + 1);
  };

  const handleArrowDownClick = () => {
    if (value === 'Free' || disabled) {
      return;
    }

    if (value === 0) {
      onChange('Free');
      return;
    }

    onChange((value as number) - 1);
  };

  return (
    <div className={getClassNames('number-picker', { disabled })}>
      <input
        className="number-picker__input"
        value={value}
        onChange={handleInputChange}
        data-testid="number-picker-input"
        disabled={disabled}
      />
      {!hideArrows && (
        <div className={getClassNames('number-picker__controls', { disabled })}>
          <ArrowUpIcon onClick={handleArrowUpClick} data-testid="number-picker-up-arrow" />
          <ArrowDownIcon onClick={handleArrowDownClick} data-testid="number-picker-down-arrow" />
        </div>
      )}
    </div>
  );
};

export default NumberPicker;
